export class Faq {
    // Constructor
    constructor( faqs, tabs ) {
        console.log('FAQ constructor');

        this.questions = faqs;
        this.tabs = tabs;

        // Add listener for the FAQ questions
        const questionTitles = this.questions.querySelectorAll('div.question h4');
        questionTitles.forEach( questionTitle => {
            questionTitle.addEventListener('click', this.toggleQuestion.bind(this));
        });
        // If we have tabs, add listeners for them
        if ( this.tabs ) {
            console.log('we have tabs');
            this.tabs.forEach( tab => {
                tab.addEventListener('click', this.filterQuestions.bind(this));
            });
        }
    }

    // Toggle the FAQ question
    toggleQuestion( e ) {
        // Get the question
        const question = e.target.closest('div.question');
        // Close all other open questions that are not this one
        const openQuestions = this.questions.querySelectorAll('div.question.open');
        openQuestions.forEach( q => {
            if ( q !== question ) { q.classList.remove('open'); }
        });
        // Toggle the open class on this question
        question.classList.toggle('open');
    }

    // Filter the questions
    filterQuestions( e ) {
        e.preventDefault();
        console.log('filterQuestions');
        // // Get the filter
        // const filter = e.target.closest('div.tab');
        // // Get the filter name
        // const filterName = filter.dataset.filter;
        // // Get the questions
        // const questions = this.questions.querySelectorAll('div.question');
        // // Display the selected questions, hide the rest
        // questions.forEach( question => {
        //     if ( question.dataset.subject === filterName ) {
        //         question.classList.remove('hidden');
        //     } else {
        //         question.classList.add('hidden');
        //     }
        // });
        // // Remove the active class from all filters
        // this.filters.forEach( f => {
        //     f.classList.remove('active');
        // });
        // // Add the active class to the selected filter
        // filter.classList.add('active');
    }
}